import { FC } from "react";
import { Fixture } from "./overview";
import { NextMatchInComponent } from "../../../components";
import "./match.css";
import MatchEventLog from "../../../components/match/MatchEventLog";
import { MatchPhone } from "refsix-js-models";
import { omit } from "lodash/fp";
import { IonButton, useIonRouter } from "@ionic/react";
import { routes } from "../../../route/constants";
import { recalculateStats, updateMatch } from "../../../services/matchService";
import { DisplayEvent } from "../../../models/DisplayEvent";
import { useTranslation } from "react-i18next";
import {
    getWatchMatchId,
    isMatchStarted,
} from "../../../services/phoneMatchWatchService";
import { useProfile } from "../../../components/hooks";
import ScrollableContentWithAds from "../../../components/ScrollableContentsWithAd";

const Match: FC<Fixture> = ({ match }) => {
    const { t } = useTranslation();
    const profile = useProfile();

    const route = useIonRouter();
    // fix for deleting the match
    if (!match) {
        return <div />;
    }

    const editEvent = (displayEvent: DisplayEvent) => {
        route.push(
            routes.refsixResultsAddEvent +
                `/${match._id}/${displayEvent.event.timestamp}`
        );
    };

    const deleteEvent = async (displayEvent: DisplayEvent) => {
        const newMatch: MatchPhone = {
            ...match,
            matchEvents: omit([displayEvent.event.timestamp], match.matchEvents),
        };
        const savedMatch = await updateMatch(newMatch);
        if (savedMatch && profile) {
            await recalculateStats(savedMatch, profile);
        }
    };

    if (!(match.matchFinished || match.matchInProgress)) {
        return (
            <ScrollableContentWithAds>
                <div style={{ textAlign: "center" }}>
                    <NextMatchInComponent match={match} />

                    <IonButton
                        style={{ marginTop: "10px" }}
                        onClick={() => {
                            route.push(
                                `${routes.startWatchPhone}/${match._id}`,
                                "none",
                                "replace"
                            );
                        }}
                        data-testid="resumeOnPhone"
                    >
                        {getWatchMatchId() === match._id && isMatchStarted()
                            ? t("fixture.Fixture.resumeOnPhone")
                            : t("fixture.Fixture.startOnPhone")}
                    </IonButton>
                </div>
            </ScrollableContentWithAds>
        );
    }

    return (
        <ScrollableContentWithAds>
            <MatchEventLog
                match={match}
                order="desc"
                edit={editEvent}
                delete={deleteEvent}
            />
        </ScrollableContentWithAds>
    );
};

export default Match;
